/**
 * 文字列処理ユーティリティークラス
 */
class StringUtil {
  /**
   * snake_case を camelCase に変換
   * @param {string} text 変換する文字列
   * @returns {string} 変換した文字列
   */
  snakeToCamel(text) {
    return text
      .split('_')
      .map((word, index) => {
        if (index === 0) return word.toLocaleLowerCase()
        return word.slice(0, 1).toUpperCase() + word.slice(1).toLowerCase()
      })
      .join('')
  }
  /**
   * HTML特殊文字をエスケープする（v-html 等での XSS 対策）
   * @param {string} text エスケープする文字列
   * @returns {string} エスケープした文字列（null/undefined は空文字）
   */
  escapeHtml(text) {
    if (text == null) return ''
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
  }
  /**
   * 対象文字列にキーワードが含まれるかチェック
   * 半角スペースは AND 検索、「 OR 」は OR 検索
   * @param {string} text 対象文字列
   * @param {string} keyword キーワード
   * @returns {boolean} キーワードが含まれていれば treu
   */
  testByKeyword(text, keyword) {
    if (keyword == null) return true
    const pattern = this.#toKeywordRegexPattern(keyword)
    return new RegExp(pattern).test(text)
  }
  /**
   * キーワードから正規表現文字列を生成
   * @param {string} keyword キーワード
   * @returns {string} 生成された正規表現文字列
   */
  #toKeywordRegexPattern(keyword) {
    const words = keyword
      // キーワード正規化
      .replace(/[.*+?^${}()|[\]\\]/g, '\\\\$&')
      // カンマ、全角カンマ、タブ、全角空白をスペースに置換
      .replace('[,、\t　]', ' ')
      // 単語（半角スペース）ごとに分割
      .split(/ /)

    // パターン文字列作成
    let pattern = ''
    for (let wordIdx = 0; wordIdx < words.length; wordIdx++) {
      const word = words[wordIdx]
      // 単語が全て小文字の時は大文字小文字を区別しない
      const ignoreCase = word === word.toLowerCase()
      if (word.toLowerCase() === 'or') {
        // OR が指定された場合
        if (wordIdx != 0 && wordIdx != words.length - 1) {
          // OR が先頭または末尾の場合は無視する（エラーとはしない）
          pattern += '|'
        }
      } else {
        const chars = [...word]
        // それ以外の文字列が指定された
        let subPattern = ''
        for (let charIdx = 0; charIdx < chars.length; charIdx++) {
          if (
            ignoreCase &&
            // アルファベットであるか
            /^[a-zA-z]+$/.test(chars[charIdx]) &&
            // 記号ではないか
            !/[!"#$%&'()*+-.,/:;<=>?@[\\\]^_`{|}~]/g.test(chars[charIdx])
          ) {
            // 単語内のアルファベットが全て英数小文字の場合は、大文字小文字を区別しない
            // 'a' → "(A|a)"
            subPattern +=
              '(' + chars[charIdx].toUpperCase() + '|' + chars[charIdx] + ')'
          } else {
            // それ以外の文字（正規化済みのため、エスケープされた文字(例えば "\.")なども、分かれて１文字ずつ処理する）
            subPattern += chars[charIdx]
          }
        }

        if (words.length == 1) {
          pattern += subPattern
        } else {
          pattern += '(?=.*' + subPattern + ')'
        }
      }
    }

    return pattern
  }
}

export default new StringUtil()
